export default __webpack_public_path__ + "static/media/DDD-Labs.a979a0fb.png";